import api_base, { serializeParams } from '@/api/base'

/**
 * A document returned by the global file listing endpoint.
 * Extends the per-case CaseFile with `case_name` injected by the backend.
 */
export interface GlobalDocument {
  id: string
  case: number
  case_name: string
  filename: string
  original_filename: string
  file_size: number
  content_type: string
  uploaded_by: { id: string; name: string }
  created_at: number | string
  file_path: string
  is_decision_file?: boolean
  analysis_generated_at?: string | null
  /** Present only in full-text search results — contains <mark>…</mark> highlighted excerpt */
  search_snippet?: string
}

export interface GlobalDocumentListResponse {
  count: number
  next: string | null
  previous: string | null
  results: GlobalDocument[]
}

export interface GlobalDocumentListParams {
  page?: number
  page_size?: number
  ordering?: string | null
  search?: string | null
  content_type?: string | null
}

export interface GlobalDocumentSearchParams {
  q: string
  limit?: number
  offset?: number
}

export const documentsService = {
  list: async (params?: GlobalDocumentListParams): Promise<GlobalDocumentListResponse> => {
    const response = await api_base.get<GlobalDocumentListResponse>('/api/v1/case/file/all', {
      params: { ...params },
      paramsSerializer: (p) => serializeParams(p),
    })
    return response.data
  },

  /** Full-text search across OCR-indexed document content */
  search: async (params: GlobalDocumentSearchParams): Promise<GlobalDocumentListResponse> => {
    const response = await api_base.get<GlobalDocumentListResponse>('/api/v1/case/file/search', {
      params: { q: params.q, limit: params.limit, offset: params.offset },
      paramsSerializer: (p) => serializeParams(p),
    })
    return response.data
  },
}
